import type { ReportProvider, ReportFilter, ReportDataset, DatasetOptions, MetricId, FilterId, ExportFormat } from '../types'
import { engineApi }         from '../../../sdk/engine.api'
import { metricsDataset }    from '../engine/dataset'

const SUPPORTED_METRICS: MetricId[] = [
  'pendingCases', 'openCases', 'resolvedToday',
  'returnedToday', 'avgResolutionTime', 'criticalCases',
]

const SUPPORTED_FILTERS: FilterId[] = [
  'date_range', 'preset', 'teams', 'members', 'status', 'priority', 'escalation_reason',
]

const SUPPORTED_EXPORTS: ExportFormat[] = ['csv', 'excel', 'json', 'pdf']

export const CustomerServiceReportProvider: ReportProvider = {
  id:                   'customer_service',
  label:                'Customer Service',
  workflowId:           'customer_service',
  supportedMetrics:     SUPPORTED_METRICS,
  supportedDimensions:  ['date', 'agent', 'team', 'status', 'priority', 'reason'],
  supportedFilters:     SUPPORTED_FILTERS,
  supportedExports:     SUPPORTED_EXPORTS,
  defaultFilter:        { workflows: ['customer_service'] },

  async buildDataset(shop: string, filter: ReportFilter, options?: DatasetOptions): Promise<ReportDataset> {
    const data = await engineApi.metrics(shop, 'customer_service')

    const resolved = data.closedToday.byOutcome['cs_completed'] ?? 0
    const returned = data.closedToday.byOutcome['cs_returned']  ?? 0

    const metrics: Record<string, number> = {
      pendingCases:       data.queued,
      openCases:          data.active,
      resolvedToday:      resolved,
      returnedToday:      returned,
      avgResolutionTime:  0,  // deferred — needs date-range metrics endpoint
      criticalCases:      0,  // deferred — needs escalation-priority query
    }

    return metricsDataset('customer_service', 'customer_service', filter, metrics, undefined, options)
  },
}
